import { IntegrationCardConnectButton } from './IntegrationConnectButton';
import { IntegrationCardConnectedButton } from './IntegrationConnectedButton';

export const IntegrationCardButton = {
    Connect: IntegrationCardConnectButton,
    Connected: IntegrationCardConnectedButton,
};
